import { SyncHistoryState } from "../models/sync-history.model";

const initialSyncHistoryState: SyncHistoryState = {
  syncHistoryList: {}
};
export default initialSyncHistoryState;
